/**
 * Created by LIDHCRT on 9/17/2018.
 */
module.exports = function(bootstrap) {
    bootstrap.run(["Service", "$q", "brand", "brandConfig", "session", "sessionData","employee",
                      function (Service, $q, brand, brandConfig, session, sessionData, employee) {

                          new Service({
                                          name: 'mcuClients',
                                          group:"eprsvc",
                                          url:"/eprsvc/x-services/secure/client/v1/mcu/search",
                                          headers: {},
                                          fetch: function (userId, bpdId) {
                                              this.url = '/eprsvc/x-services/secure/client/v1/mcu/search?userId=' + userId + '&bpdId=' + bpdId;
                                              this.headers['FromDP'] = sessionData.basicInfo.loginId;
                                              return this.get();


                                          },


                                      });
                      }]);
};


